import { Link } from "react-router-dom"
import "./PromoBanner.css"

/**
 * A dark lifecycle banner card: an icon, a title, a short description and a
 * chevron, the whole card being the link. `to` is an in-app route; `href` an
 * external URL, opened in a new tab.
 * @param {string} icon - Bootstrap icon class, e.g. "bi-download"
 * @param {string} title
 * @param {string} [to]
 * @param {string} [href]
 */
export default function PromoBanner({ icon, title, to, href, children }) {
    const content = (
        <>
            <i className={`bi ${icon} promo-banner-icon`} aria-hidden="true"></i>
            <div className="promo-banner-text">
                <h2 className="promo-banner-title">{title}</h2>
                <p className="promo-banner-body">{children}</p>
            </div>
            <i
                className="bi bi-chevron-right promo-banner-chevron"
                aria-hidden="true"
            ></i>
        </>
    )

    if (to) {
        return (
            <Link className="promo-banner text-start" to={to}>
                {content}
            </Link>
        )
    }

    return (
        <a
            className="promo-banner text-start"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
        >
            {content}
        </a>
    )
}
